import {REQUEST} from "../../../util/Request";
import * as types from "./types";

export const SeguridadReducer = (state = {}, action) => {
  switch (action.type) {
    case types.CONSULTAR_KEY_CAPTCHA:
      return {
        ...state,
        estadoConsultarKeyCaptcha: REQUEST.PENDING
      };
    case types.KEY_CAPTCHA_CONSULTADA:
      return {
        ...state,
        key: action.key,
        estadoConsultarKeyCaptcha: REQUEST.SUCCESS
      };
    case types.ERROR_CONSULTANDO_KEY_CAPTCHA:
      return {
        ...state,
        key: undefined,
        estadoConsultarKeyCaptcha: REQUEST.ERROR,
        errorConsultarKeyCaptcha: action.error
      };
    case types.LIMPIAR_STATE_SEGURIDAD:
      return {
        ...state,
        key: undefined,
        estadoConsultarKeyCaptcha: undefined,
        errorConsultarKeyCaptcha: undefined
      };
    default:
      return state;
  }
};
